import React, { FC, useState } from 'react';

import { Center, Text } from '@chakra-ui/layout';
import { useUpdateEffect } from '@chakra-ui/react';

import { washHub } from 'store/slices';
import { useParams } from 'react-router-dom';

import { useQuery } from 'react-query';
import { fetchHistory } from 'api/history';

import { DataTable } from 'components/modules/DataTable';
import { History } from 'types/history';

import { scansItemsColumns } from './scansItemsColumns';

export const ScansItemsTable: FC = () => {
  const params = useParams<{ id: string }>();

  const [page, setPage] = useState<number>(1);

  const washHubId = washHub.selectors.useSelectedWashHubId();
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();
  const queryKey = `fetch-all-scan-item-${washHubId}-${params?.id}`;

  const queryFn = () =>
    fetchHistory({
      page,
      limit: 10,
      washHub: washHubId,
      scanId: params?.id,
    });

  const options = {
    enabled: isWashHubIdValid,
    keepPreviousData: true,
  };

  const { data, refetch, isFetching, isLoading } = useQuery(
    queryKey,
    queryFn,
    options,
  );

  useUpdateEffect(() => {
    refetch();
  }, [page]);

  const items = data?.items || [];
  const totalCount = data?.total || 0;
  const totalPages = data?.totalPages || 0;

  const pagination = {
    page,
    setPage,
    totalCount,
    totalPages,
  };

  return (
    <DataTable<History>
      minW="410px"
      data={items}
      columns={scansItemsColumns}
      isLoading={isLoading || isFetching}
      pagination={pagination}
      renderEmpty={() => (
        <Center p={8}>
          <Text fontSize="20px">No Items available</Text>
        </Center>
      )}
    />
  );
};
